import { MSG_ERRO_SERVIDOR } from '../../shared/constantes/mensagens';

const INITIAL_STATE = {
  esperandoSolicitacao: false,
  mensagem: '',
  erro: false,
  dados: null,
  year: new Date().getFullYear() - 1
};

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    /* Actions para Extrato em JSON */
    case 'EIR_EXTRATO_SOLICITADO':
      return { ...state, esperandoSolicitacao: true, mensagem: "", erro: false };
    case 'EIR_EXTRATO_SUCESSO':
      return { ...state, esperandoSolicitacao: false, erro: false, mensagem: "", dados: action.payload };
    case 'EIR_EXTRATO_ERRO':
      return { ...state, esperandoSolicitacao: false, mensagem: (typeof action.payload == "string") ? action.payload : MSG_ERRO_SERVIDOR, dados: null, erro: true };
    case 'EIR_NAO_ENCONTRADO':
      return { ...state, erro: false, esperandoSolicitacao: false, mensagem: 'no_content' };
    case 'EIR_PENDENTE_CORRECAO':
      return {
        ...state, erro: true, esperandoSolicitacao: false,
        mensagem: action.payload ?? "Encontramos problemas para emitir o Extrato de Imposto de Renda. Solicite o serviço 'Atualizar Dados do Imposto de Renda Direto na Fonte (DIRF)'"
      }

    /* Actions para Extrato em PDF */
    case 'EIR_EXTRATO_PDF_SOLICITADO':
      return { ...state, esperandoSolicitacao: true, erro: false, mensagem: '' }
    case 'EIR_EXTRATO_PDF_SUCESSO':
      return { ...state, esperandoSolicitacao: false, erro: false, mensagem: 'sucesso' }
    case 'EIR_EXTRATO_PDF_ERRO':
      return { ...state, esperandoSolicitacao: false, erro: true, mensagem: '' };
    /* Actions geral */
    case 'EIR_ANO_ATUALIZADO':
      return { ...state, year: action.payload }
    default:
      return state;
  }
}
